// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React from "react";
import { css } from "styled-components";

export interface BrandDetailsPageStyles {
    brandContainer?: GridContainerProps;
    brandImage?: GridItemProps;
    brandContent?: GridItemProps;
    brandLogo?: GridItemProps;
    brandButtons?: GridItemProps;
    brandSubBrands?: GridItemProps;
    brandCategories?: GridItemProps;
}

const styles: BrandDetailsPageStyles = {
    brandContainer: {
        gap: 15,
        css: css`
            flex-wrap: wrap;
        `,
    },
    brandImage: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
    brandContent: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
    brandLogo: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
    brandButtons: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
    brandSubBrands: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
    brandCategories: {
        css: css`
            margin-bottom: 25px !important;
        `,
    },
};

const BrandDetialsPageContainer = ({ id }: WidgetProps) => {
    return (
        <GridContainer {...styles.brandContainer}>
            <GridItem width={12} {...styles.brandImage}>
                <Zone zoneName="content0" contentId={id} />
            </GridItem>
            <GridItem width={[12, 12, 10, 10, 10]} {...styles.brandContent}>
                <Zone zoneName="content1" contentId={id} />
            </GridItem>
            <GridItem width={[12, 12, 2, 2, 2]} {...styles.brandLogo}>
                <Zone zoneName="content2" contentId={id} />
            </GridItem>
            <GridItem width={12} {...styles.brandButtons}>
                <Zone zoneName="content3" contentId={id} />
            </GridItem>
            <GridItem width={12} {...styles.brandSubBrands}>
                <Zone zoneName="content4" contentId={id} />
            </GridItem>
            <GridItem width={12} {...styles.brandCategories}>
                <Zone zoneName="content5" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetialsPageContainer,
    definition: {
        group: "Brand Details",
        allowedContexts: [BrandDetailsPageContext],
        displayName: "Page Container Layout",
    },
};

export default widgetModule;
